module.exports = __webpack_public_path__ + "images/12b8248a7343ebfa0f89cf9942997a373.svg";